import {
    FILTER_TYPE_CHECKBOX,
} from "../constant";
import defaultI18n from "../i18nService";
import {PreferenceType, PreferenceWhen} from "./preferenceTypes";

export const PREFERENCE_FILTER_GROUP_INCLUDE = 'include';
export const PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE = 'preferenceType';
export const PREFERENCE_FILTER_GROUP_WHEN = 'when';
export const PREFERENCE_FILTER_GROUP_GROUPS = 'group';

export const NO_GROUP = "no-group";

export const createListOfFilters = (i18n = defaultI18n) => {
    return [
        {
            filterTitle: i18n.t('preference.scheme.include.true'),
            filterName: `${PREFERENCE_FILTER_GROUP_INCLUDE}.true`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_INCLUDE,
        },
        {
            filterTitle: i18n.t('preference.scheme.include.false'),
            filterName: `${PREFERENCE_FILTER_GROUP_INCLUDE}.false`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_INCLUDE,
        },
        {
            filterTitle: i18n.t(`preference.scheme.preferenceType.${PreferenceType.PRODUCT}`),
            filterName: `${PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE}.${PreferenceType.PRODUCT}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE,
        },
        {
            filterTitle: i18n.t(`preference.scheme.preferenceType.${PreferenceType.RECIPE}`),
            filterName: `${PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE}.${PreferenceType.RECIPE}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE,
        },
        {
            filterTitle: i18n.t(`preference.scheme.preferenceType.${PreferenceType.RECIPE_CHARACTERISTIC}`),
            filterName: `${PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE}.${PreferenceType.RECIPE_CHARACTERISTIC}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE,
        },
        {
            filterTitle: i18n.t(`preference.scheme.preferenceType.${PreferenceType.PROPERTY}`),
            filterName: `${PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE}.${PreferenceType.PROPERTY}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE,
        },
        {
            filterTitle: i18n.t(`preference.scheme.preferenceType.${PreferenceType.COMBINATION}`),
            filterName: `${PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE}.${PreferenceType.COMBINATION}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_PREFERENCE_TYPE,
        },
        {
            filterTitle: i18n.t(`preference.scheme.when.${PreferenceWhen.MORNING}`),
            filterName: `${PREFERENCE_FILTER_GROUP_WHEN}.${PreferenceWhen.MORNING}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_WHEN,
        },
        {
            filterTitle: i18n.t(`preference.scheme.when.${PreferenceWhen.AFTER_MORNING}`),
            filterName: `${PREFERENCE_FILTER_GROUP_WHEN}.${PreferenceWhen.AFTER_MORNING}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_WHEN,
        },
        {
            filterTitle: i18n.t(`preference.scheme.when.${PreferenceWhen.AFTERNOON}`),
            filterName: `${PREFERENCE_FILTER_GROUP_WHEN}.${PreferenceWhen.AFTERNOON}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_WHEN,
        },
        {
            filterTitle: i18n.t(`preference.scheme.when.${PreferenceWhen.BEFORE_EVENING}`),
            filterName: `${PREFERENCE_FILTER_GROUP_WHEN}.${PreferenceWhen.BEFORE_EVENING}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_WHEN,
        },
        {
            filterTitle: i18n.t(`preference.scheme.when.${PreferenceWhen.EVENING}`),
            filterName: `${PREFERENCE_FILTER_GROUP_WHEN}.${PreferenceWhen.EVENING}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_WHEN,
        },
        {
            filterTitle: i18n.t(`preference.scheme.when.${PreferenceWhen.NIGHT}`),
            filterName: `${PREFERENCE_FILTER_GROUP_WHEN}.${PreferenceWhen.NIGHT}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_WHEN,
        },
        {
            filterTitle: i18n.t(`preference.scheme.when.${PreferenceWhen.NO_MATTER}`),
            filterName: `${PREFERENCE_FILTER_GROUP_WHEN}.${PreferenceWhen.NO_MATTER}`,
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: PREFERENCE_FILTER_GROUP_WHEN,
        },
    ];
};
